let questions = document.getElementsByClassName('question')
Array.from(questions).forEach(q => {
    q.onclick = e => {
      let a = e.target.parentElement.getElementsByClassName('answer')[0]
      if (a.classList.contains('hide')) {
        a.classList.remove('hide')
        q.classList.add('active')
      } else {
        a.classList.add('hide')
        q.classList.remove('active')
      }
    }
})
